import { render, staticRenderFns } from "./r-tab.vue?vue&type=template&id=571ef909"
import script from "./r-tab.vue?vue&type=script&setup=true&lang=js"
export * from "./r-tab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./r-tab.vue?vue&type=style&index=0&id=571ef909&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports